export type GoogleAddressComponent = { long_name: string; short_name: string; types: string[] };

export type Address = {
  streetAddress1: string;
  streetAddress2?: string;
  city: string;
  state: string;
  postalCode: string;
  addressCountry: string;
};

export const fromGooglePlace: (components: GoogleAddressComponent[]) => Address = (components) => {
  const result: Record<string, string> = {};
  const keys = new Set(['street_number', 'route', 'locality', 'administrative_area_level_1', 'postal_code', 'country']);

  components.forEach((component) => {
    const type = component.types.find((type) => keys.has(type));

    if (!type) {
      return;
    }

    result[component.types[0]] = component.long_name;
  });

  const streetNumber = result.street_number && `${result.street_number} `;

  return {
    streetAddress1: `${streetNumber ?? ''}${result.route}`,
    city: result.locality,
    state: result.administrative_area_level_1,
    postalCode: result.postal_code,
    addressCountry: result.country,
  };
};
